import React, { useContext, useEffect, useRef, useState } from "react";
import { useForm } from "../../../../../../Base/Hooks/useForm";
import { Toast } from "primereact/toast";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import AutoCompleteDropdown from "../../../../../../Base/Components/Form/AutoCompleteDropdown";
import { editarRouter, getMarcas, guardarRouter } from "../../../../../../API/IT/Dispositivos/DispositivosRequest";
import { getAreasAct } from "../../../../../../Base/API/Global/Areas/AreasRequests";
import { getEstadosCategory } from "../../../../../../API/Global/Status/StatusRequests";
import { InputTextarea } from "primereact/inputtextarea";
import { Button } from "primereact/button";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";
import { toastShow } from "../../../../../../Base/Services/ToastService";
import { getActivosFijos } from "../../../../../../API/Global/ActivosFijos/ActivosFijosRequest";

const RouterCRUD = ({
  listRouters,
  showDialog,
  router,
  setShowDialog,
  getInfo,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [loading, setLoading] = useState(false);
  const [estados, setEstados] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [areas, setAreas] = useState([]);
  const [activos, setActivos] = useState([]);

  const initialValues = {
    IdRouter: -1,
    IdEstado: router ? router?.IdEstado : 5,
  };

  const { values, handleInputChange, setValues, resetForm, error, setError } =
    useForm(initialValues);

  const getValoresIniciales = async () => {
    setLoading(true);

    const marcasTempo = await getMarcas();
    setMarcas(marcasTempo);

    const areasTempo = await getAreasAct();
    setAreas(areasTempo);

    const activosTempo = await getActivosFijos();
    const activosFilter = activosTempo.filter((e) =>
      [47].includes(e?.IdTipoActivo)
    );
    setActivos(activosFilter);

    const estadosTempo = await getEstadosCategory("General");
    setEstados(estadosTempo);

    const estadoActivo =
      router?.IdRouter > 0
        ? estadosTempo.find((e) => e.IdStatus === router?.IdEstado)
        : estadosTempo.find((e) => e.IdStatus === 5);

    setValues({
      ...router,
      Marca: marcasTempo.find((m) => router?.IdMarca === m.IdMarca),
      Area: areasTempo.find((a) => router?.IdArea === a.IdArea),
      Activo: activosTempo.find((a) => router?.IdActivo === a.IdActivo),
      Estado: estadoActivo,
    });

    setLoading(false);
  };

  const verificarInfo = () => {
    let error = {};
    if (!values.IP) {
      error.IP = true;
      error.error = true;
    }
    if (!values.SSID) {
      error.SSID = true;
      error.error = true;
    }
    if (!values.ClaveSSID) {
      error.ClaveSSID = true;
      error.error = true;
    }
    if (!values.ClaveRouter) {
      error.ClaveRouter = true;
      error.error = true;
    }
    if (!values.Area || !values.Area.IdStatus) {
      error.IdArea = true;
      error.error = true;
    }
    if (!values.Estado || !values.Estado.IdStatus) {
      error.IdEstado = true;
      error.error = true;
    }
    setError(error);
    // console.log(error);
    return error;
  };

  const agregar = async () => {
    const e = verificarInfo();
    if (!e.error) {
      const Datos = {
        IdRouter: values?.IdRouter,
        IP: values?.IP,
        SSID: values?.SSID,
        ClaveSSID: values?.ClaveSSID,
        ClaveRouter: values?.ClaveRouter,
        IdMarca: values?.Marca?.IdMarca,
        Modelo: values?.modelo,
        Serie: values?.serie,
        IdArea: values?.Area?.IdArea,
        IdActivo: values?.Activo?.IdActivo,
        // IdEstado: values?.Estado?.IdStatus,
        Ubicacion: values?.Ubicacion,
        IdUserCreated: userAuth?.IdUser,
        IdUserEdit: userAuth?.IdUser,
      };
      console.log(Datos);
      setLoading(true);

      if (Datos.IdRouter > 0) {
        const resultado = await editarRouter(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toast,
            "success",
            "Datos Editados",
            resultado[0]?.MENSAJE
          );
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(toast, "error", "Error al Editar", resultado[0]?.MENSAJE);
        }
      } else {
        const resultado = await guardarRouter(Datos);
        if (resultado[0]?.ESTADO === 1) {
          toastShow(
            toast,
            "success",
            "Datos Agregados",
            resultado[0]?.MENSAJE
          );
          getInfo();
          setTimeout(() => {
            onHide();
            setLoading(false);
          }, 1300);
        } else {
          toastShow(
            toast,
            "error",
            "Error al agregar",
            resultado[0]?.MENSAJE
          );
        }
      }
    }
  };

  const onHide = () => {
    setShowDialog(false);
    resetForm();
    setError({});
  };

  const DialogFooter = (
    <React.Fragment>
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={onHide}
      />
      <Button
        label={router?.IdRouter ? "Editar" : "Guardar"}
        icon="pi pi-check"
        className="p-button-text"
        onClick={() => {
          agregar();
        }}
        loading={loading}
      />
    </React.Fragment>
  );

  useEffect(() => {
    if (showDialog) {
      getValoresIniciales();
    }
  }, [showDialog]);

  const dialogTitle = router?.IdRouter > 0 ? "Editar Router" : "Agregar Router";

  return (
    <div>
      <Dialog
        visible={showDialog}
        modal
        className="modal__contenedor1"
        footer={DialogFooter}
        onHide={onHide}
        header={dialogTitle}
        style={{ width: "60%" }}
      >
        <div id="Dialog">
          <Loader loading={loading} querySelector={"#Dialog"} />
          <div style={{ margin: "auto" }}>
            <Toast ref={toast} style={{ zIndex: 50000 }} />

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="IP"
                    value={values?.IP}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IP ? "p-invalid" : ""}
                  />
                  <label htmlFor="IP">IP</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="SSID"
                    value={values?.SSID}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.SSID ? "p-invalid" : ""}
                  />
                  <label htmlFor="SSID">SSID</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="ClaveSSID"
                    value={values?.ClaveSSID}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.ClaveSSID ? "p-invalid" : ""}
                  />
                  <label htmlFor="ClaveSSID">Clave SSID</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="ClaveRouter"
                    value={values?.ClaveRouter}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.ClaveRouter ? "p-invalid" : ""}
                  />
                  <label htmlFor="ClaveRouter">Clave Router</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Marca"}
                    value={values?.Marca}
                    items={marcas}
                    field={"Marca"}
                    label={"Marca"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdMarca ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="modelo"
                    value={values?.modelo}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.modelo ? "p-invalid" : ""}
                  />
                  <label htmlFor="modelo">Modelo</label>
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-4">
                <span className="p-float-label">
                  <InputText
                    name="serie"
                    value={values?.serie}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.serie ? "p-invalid" : ""}
                  />
                  <label htmlFor="serie">Serie</label>
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Area"}
                    value={values?.Area}
                    items={areas}
                    field={"Area"}
                    label={"Area"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdArea ? "p-invalid" : ""}
                  />
                </span>
              </div>

              <div className="field col-4">
                <span className="p-float-label">
                  <AutoCompleteDropdown
                    name={"Activo"}
                    value={values?.Activo}
                    items={activos}
                    field={"NombreActivo"}
                    label={"Activo"}
                    handleInputChange={handleInputChange}
                    abelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.IdActivo ? "p-invalid" : ""}
                  />
                </span>
              </div>
            </div>

            <div className="modal__input-contenedor gap-2">
              <div className="field col-8">
                <span className="p-float-label">
                  <InputTextarea
                    name="Ubicacion"
                    value={values?.Ubicacion}
                    onChange={handleInputChange}
                    style={{ width: "100%" }}
                    labelStyle={{
                      color: "gray",
                      textShadow: "0px 0px 1px white",
                    }}
                    className={error.Ubicacion ? "p-invalid" : ""}
                  />
                  <label htmlFor="Ubicacion">Ubicación</label>
                </span>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default RouterCRUD;
